import {
    REMOVE_ORDER_ITEM_START,
    REMOVE_ORDER_ITEM_SUCCESS,
    REMOVE_ORDER_ITEM_ERROR
} from '../../constants';
import history from '../../history';
import { removeOrderItem as mutation, getOrder as query } from '../../lib/graphql';
import { startItemLoader, stopItemLoader } from '../loader/loader';
import { encode } from '../../helpers/queryEncryption';

export function removeOrderItemAction({ categoryId, subCategoryId, orderId, isLastOrderItem, promoId }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: REMOVE_ORDER_ITEM_START,
            });
            dispatch(startItemLoader('removeOrderLoading', subCategoryId));

            const { data } = await client.mutate({
                mutation,
                variables: {
                    subCategoryId,
                    orderId,
                    isLastOrderItem: isLastOrderItem == true ? true : false
                },
                refetchQueries: [{ query, variables: { promoId } }]
            })
            if (data?.removeOrderItem?.status === 200) {
                dispatch(stopItemLoader('removeOrderLoading', subCategoryId));
                isLastOrderItem && history.push(`/category?type=${encodeURIComponent(encode(categoryId?.toString()))}`)
                dispatch({
                    type: REMOVE_ORDER_ITEM_SUCCESS,
                });
            } else {
                dispatch(stopItemLoader('removeOrderLoading', orderId));
                dispatch({ type: REMOVE_ORDER_ITEM_ERROR });
            }
        } catch (error) {
            dispatch({
                type: REMOVE_ORDER_ITEM_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}